import { z } from "zod";

export const sessionTypes = [
  "headshot_light",
  "headshot_dark",
  "editorial_solo",
  "editorial_team",
] as const;
export type SessionType = (typeof sessionTypes)[number];
export const sessionTypeSchema = z.enum(sessionTypes);

export const sessionImages: Record<SessionType, string> = {
  headshot_light: "/scheduling/headshot-light.jpeg",
  headshot_dark: "/scheduling/headshot-dark.jpeg",
  editorial_solo: "/scheduling/editorial-solo.jpeg",
  editorial_team: "/scheduling/editorial-team.jpeg",
};
